import { Body, Controller, Post } from '@nestjs/common';
import {
    AllProcurementTypesResponseModel, ProcurementTypeResponse
  } from '@gtpl/shared-models/procurement-management';
import { ApiBearerAuth} from '@nestjs/swagger';
import { ProcurementTypesService } from './procurement-types.service';
import {
    InternalServerError,
    errorHandler, ApplicationExceptionHandler
  } from '@gtpl/shared-utils/error-messages';
import { ProcurementTypesDto } from 'libs/shared-models/procurement-management/src/lib/procurement-types/procurement-types-dto';
import { ProcurementTypeRequest } from './dto/procurement-type-request';
import { ApiTags } from '@nestjs/swagger';
import { CustomerEnum, MessageRequest, MessageResponse } from '@gtpl/shared-models/common-models';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
  @ApiBearerAuth()
  @ApiTags('procurementType')
  @Controller('procurement-types')
export class ProcurementTypesController {
    constructor(private procurementTypeService: ProcurementTypesService, private readonly applicationExceptionHandler: ApplicationExceptionHandler, private wpService: WhatsAppNotificationService) { }
    ProcurementTypesService: ProcurementTypesService;
    // private authModel: AuthModel,


    /**
         * creates or updates a ProcurementType
         * @param procurementType procurement DTO
         * @returns ProcurementTypeResponse
         */
    @Post('/saveProcurementType')
    async saveProcurementType(@Body() procurementType: ProcurementTypesDto): Promise<ProcurementTypeResponse> {
        try {
            return await this.procurementTypeService.saveProcurementType(procurementType);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ProcurementTypeResponse, error);
        }
    }

    /**
     * gets all the Procurement Types
     * @returns AllProcurementTypesResponseModel which returns all the Procurement Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

  @Post('/getAllProcurementTypes')
  async getAllProcurementTypes(): Promise<AllProcurementTypesResponseModel> {
    try {
      return await this.procurementTypeService.getAllProcurementTypes();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllProcurementTypesResponseModel, error);
    }
  }

    /**
     * Activate Or De-Activate Sample Type
     * @param getSingleSampleType 
     * @returns SampleTypeResponse
     */
   @Post('/activateOrDeactivateSampleTypeBySampleTypeCode')
   async activateOrDeactivateProcurementType(@Body() procurementTypeRequest: ProcurementTypeRequest): Promise<ProcurementTypeResponse> {
       try {
           return await this.procurementTypeService.activateOrDeactivateProcurementeType(procurementTypeRequest);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(ProcurementTypeResponse, err);
       }
   }

  
  @Post('/testWhatsAppMessage')
  async testWhatsAppMessage(@Body() message: MessageRequest): Promise<MessageResponse> {
    // sample request object
    // const msg1 = new MessageRequest("Greetings", "How are you", "Schemax", CustomerEnum.GRP_SANDHYA_AQUA_COMMON);
    // const msg2 = new MessageRequest("", "How are you", "Schemax", CustomerEnum.GRP_SANDHYA_AQUA_COMMON);
    // const msg3 = new MessageRequest("", "How are you", "", CustomerEnum.GRP_SANDHYA_AQUA_COMMON);
    return await this.wpService.sendPersonalMessage(message);
  }
}
